export default {
   errorMsg:{
      required:"此項是必填選項",
      minValue:"數字必須大於",
      maxValue:"數字必須小於 ",
      minLength:"填入字符長度需大於 ",
      maxLength:"填入字符長度需小於 ",
      numeric: "請填入正整數",
      decimal: "請填入有效數字",
      policy: "此項只能填寫字母，數字以及 '-'",
      email: "請填入有效電子郵件",
      alphaNum: "此項只能填寫字母及數字",
      between: "數字必須介於 ",
      between_and: " 至 ",
    },
    alertMsg:{
      error:"發現未填寫或錯誤的必填選項，請檢查紅色項目並重新提交。",
      
    },

}


// WEBPACK FOOTER //
// ./src/Validation/langs/zh_hk/index.js